import React from 'react';
import { Grid } from '@mantine/core';
import { useSelector } from 'react-redux';
import DashboardsCommon from '../DashboardsCommon';

const AbTestChartView = ({ chart }) => {
  const { domain } = useSelector((state) => state.domain);

  const generatePieCharatData = (chart) => {
    if (chart.name === 'averageOrderValueByGroup') {
      return chart.data
        ? chart.data.map((r) => {
            return {
              id: r.id,
              label: r.id,
              value: r.data.reduce((accu, point) => accu + point.y, 0.0) / r.data.length,
            };
          })
        : '';
    }
    return chart.data
      ? chart.data.map((r) => {
          return { id: r.id, label: r.id, value: r.data.reduce((accu, point) => accu + point.y, 0.0) };
        })
      : '';
  };

  return (
    <Grid>
      <Grid.Col>
        <DashboardsCommon
          stats={chart.data}
          pieChartData={generatePieCharatData(chart)}
          currency={chart.haveCurrency ? domain.currency : null}
          lineStacked={false}
          expand={true}
        />
      </Grid.Col>
    </Grid>
  );
};

export default AbTestChartView;
